<template>
  <div class="top-menu" :class=" activeSection ? 'active' : ''" id="console_nav">
    <div v-if="activeSection">
      <img @click="goBackToComponent" src="@/assets/imgs/left-arrow.svg">
    </div>
     <a v-else class="menu-mobile" href="javascript: history.go(-1)">
      <img src="@/assets/imgs/left-arrow.svg">
    </a>
  </div>
</template>

<script>
import { WizardManager } from '@/state'
export default {
  name: 'Menu',
  props: {
    activeSection: null,
    allSections: null,
    page: false
  },
  data () {
    return {
      wizardManager: {}
    }
  },
  methods: {
    goBackToComponent () {
      this.wizardManager = JSON.parse(localStorage.getItem('wizardManager'))
      var keys = Object.values(WizardManager.flow)
      let index = keys.findIndex(x => x.key === this.activeSection.key)
      if (WizardManager.ChildWizard.flow.length > 0) {
        var childKeys = Object.values(WizardManager.ChildWizard.flow)
        let childIndex = childKeys.findIndex(x => x.key === this.activeSection.key)
        if (childIndex > -1) {
          if (this.activeSection['key'] === WizardManager.ChildWizard.flow[0].key) {
            this.$emit('goBackToComponent', WizardManager.flow[index - 1])
            WizardManager.flow.pop()
            this.wizardManager.flow.pop()
            localStorage.setItem('wizardManager', JSON.stringify(this.wizardManager))
          } else {
            this.$emit('goBackToComponent', WizardManager.ChildWizard.flow[childIndex - 1])
            WizardManager.ChildWizard.flow.pop()
            this.wizardManager.ChildWizard.flow.pop()
            localStorage.setItem('wizardManager', JSON.stringify(this.wizardManager))
            console.log('this.wizardManager', this.wizardManager)
          }
        } else {
          this.$emit('goBackToComponent', WizardManager.flow[index - 1])
          WizardManager.flow.pop()
          this.wizardManager.flow.pop()
          localStorage.setItem('wizardManager', JSON.stringify(this.wizardManager))
        }
      } else {
        this.$emit('goBackToComponent', WizardManager.flow[index - 1])
        WizardManager.flow.pop()
        this.wizardManager.flow.pop()
        localStorage.setItem('wizardManager', JSON.stringify(this.wizardManager))
      }
    }
  }
}
</script>
